<template>
<!-- pc端 -->
  <div id="pc" v-if="isMaxScreen">
       <!-- 头部log和search模块开始 -->
    <div class="box">
        <div class="left">
          <img src="@/assets/img_pc/logo.png" alt="">
          <!-- <div></div> -->
          <span class="border_left">
            <img src="@/assets/img_pc/header2.png" alt="">
          </span>
      </div>
      <div class="input-box" @keyup.enter="onQuery">
        <input v-model.trim="searchs" type="text" placeholder="请输入关键词">
        <div class="search">
          <span class="el-icon-search" @click="onQuery"></span>
        </div>
      </div>
    </div>
        <!-- 头部log和search模块结束 -->

        <!-- 头部导航栏模块开始 -->
    <div class="pc_nav">
      <div class="tab-box">
          <div class="list"
             v-for="(item, index) in this.$nav1" :key="index"
             @click="isPush(item)">
          <span :style="{color: ids === item.id ? '#E88E0D' : ''}">{{item.name}}</span>
        </div>
      </div>
    </div>
        <!-- 头部导航栏模块结束  -->
  </div>

  <HearderH5 v-else />

</template>

<script>
import HearderH5 from '@/components/Main/main_h5/hearder_h5'
import { mapState } from 'vuex'
export default {
  name: 'Header',
  components: { HearderH5 },
  data () {
    return {
      isMaxScreen: true,
      searchs: null,
      id: 0
    }
  },
  watch: {
    screenWidth: function (val) {
      // 监听屏幕宽度变化
      // console.log("val",val)
      this.isMaxScreen = val > 850
      // console.log(this.isMaxScreen)
    }
  },
  computed: {
    ...mapState(['ids'])
  },
  mounted () {
    this.isMaxScreen = document.body.clientWidth > 850
    window.addEventListener('resize', () => {
      // console.log("000",document.body.clientWidth)
      console.log('banner', document.body.clientWidth)
      this.isMaxScreen = document.body.clientWidth > 850
      // console.log("this.isMaxScreen",this.isMaxScreen)
    })
  },
  methods: {
    isPush (item) {
      this.$store.commit('setIds', item.id)
      if (item.flag) {
        window.open(item.url)
      } else {
        this.$router.push(item.url)
        console.log(this.$route)
      }
    },
    async onQuery () {
      if (!this.searchs) return alert('请输入要查询的内容')
      const { data } = await this.$get('/ow/article', { title: this.searchs })
      this.$store.commit('SearchList', data)
      this.$router.push('/search?ids=0')
    }
  }
}
</script>

<style scoped lang="scss">
  #pc{
    color: #006699;
    background: #fff;
    width: 100%;
  .box {
    height: 98px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 1200px;
    margin: 0 auto;
    overflow: hidden;

    .left{
        display: flex;
        position: relative;
        align-items: center;
        justify-content: space-between;
        width: 750px;
        height: 90px;
        img{
          width: 531px;
          height: 100%;
          object-fit: cover;
        }
        .border_left {
          width: 220px;
          height: 51px;
          padding-left: 10px;
          font-weight: 700;
          border-left: 1px solid #006699;
          img {
            width: 100%;
          }
        }
        span {
          font-size: 38px;
        }
      }
    .input-box{
      position: relative;
      display: flex;
      height: 34px;
      align-items: center;
      justify-content: space-between;
      margin-right: 20px;
      border: 1px solid #AAAAAA;
      border-radius: 2px;
      input{
        border: none;
        outline: none;
        padding: 0 14px;
        width: 260px;
        height: 30px;
         background: rgba(255, 255, 255, .3);
        border-radius: 4px;
        font-size: 12px;
        font-weight: 400;
        &::-webkit-input-placeholder {
          color: #E4E4E4;
          font-size: 12px;
        }
      }

      .search{
        .el-icon-search {
          color: #4E55AF;
        }
        span{
          position: absolute;
          top: 9px;
          right: 0;
          width: 15px;
          height: 15px;
          font-size: 15px;
          margin-right: 12px;
          font-weight: 700;
        }
      }
    }
  }
  .pc_nav {
    min-width: 100%;
    background: #4E55AF;
    .tab-box{
      display: flex;
      width: 1200px;
      margin: 0 auto;
      align-items: center;
      justify-content: space-between;
      font-size: 18px;
      color: #fff;
      .list{
        cursor: pointer;
        padding: 14px 20px 14px 20px;
        &:hover {
          color: #E88E0D;
        }
        .zhaosheng {
          color: #F7F7F7;
        }
      }
      .active {
        color: #E88E0D;
      }

    //   .news {
    //     position: relative;
    //     &:hover .xuanxiang {
    //       display: block;
    //     }
    //     .xuanxiang {
    //       position: absolute;
    //       top: 52px;
    //       left: 0;
    //       z-index: 99;
    //       display: none;
    //       li {
    //         padding: 14px 20px 14px 20px;
    //         background: #AE1D44;
    //         &:hover {
    //           background: #650201;
    //           color: #f7f7f7;
    //       }
    //     }
    //   }
    // }
    }
  }

}

</style>
